<mat-toolbar color="primary">
    <!-- <span class="title-center">{{title}}</span> -->
    <span class="title-center">Email Template</span>
</mat-toolbar>

<form [formGroup]="emailTemplate" class="content" fxLayout="column"
    fxLayout.sm="column" fxLayout.xs="column">
    <mat-form-field class="input-field">
        <input type="text" placeholder="Email Template Name" matInput
            maxlength="50" required
            formControlName="emailTemplateName" [readonly]='isReadOnly'>
    </mat-form-field>
    <mat-form-field class="input-field">
        <input type="text" placeholder="Subject" matInput maxlength="150"
            required formControlName="subject">
    </mat-form-field>
    <div fxLayout="row" fxLayout.lt-sm="column">
        <mat-form-field class="input-field" fxFlex="50%" fxFlexFill
           >
            <mat-select formControlName="formFields" placeholder="Select form
                fields">
                <mat-option *ngFor="let formField of formFields"
                    [value]="formField.value">{{formField.name}}

                </mat-option>
            </mat-select>
        </mat-form-field>
        <button *ngIf="emailTemplate.get('formFields').value !== ''"
            mat-raised-button (click)="onDone()"
            color="primary" fxFlex="20%" fxFlexFill>Done</button>
    </div>
    <div class='editor'>
        <!-- <app-ngx-editor [config]="editorConfig" required 
        formControlName="emailTemplateDescr" 
        [spellcheck]="true">
        </app-ngx-editor> -->
        <quill-editor formControlName="emailTemplateDescr"
            [modules]='editorConfig' placeholder='Enter text here...'>
        </quill-editor>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center"
        class="email-button">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button *ngIf="isEditMode && !isReadOnly" mat-raised-button
            (click)="onDelete()" color="warn">Delete</button>
        <button *ngIf="isEditMode" mat-raised-button (click)="onUpdate()"
            color="primary">Update</button>
        <button *ngIf="!isEditMode" mat-raised-button (click)="onSubmit()"
            color="primary"
            [disabled]="emailTemplate.invalid">Submit</button>
    </div>
</form>